import {ModuleConfiguration} from "../router/model/UserPermission";
import {EmployeeAutocompleteModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const AutocompleteModuleConfiguration = new ModuleConfiguration(EmployeeAutocompleteModuleName,
    [AngularJsMaterialModuleName]);